import React from 'react';

import './../css/footer.css';
import './../css/custom.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container text-center">
                <p className="text-muted">©︎Yodai 2025-</p>
            </div>
        </footer>
    );
};

export default Footer;